import { render, staticRenderFns } from "./booking-list-container.vue?vue&type=template&id=a5c64a32&scoped=true&"
import script from "./booking-list-container.vue?vue&type=script&lang=js&"
export * from "./booking-list-container.vue?vue&type=script&lang=js&"
import style0 from "./booking-list-container.vue?vue&type=style&index=0&id=a5c64a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c64a32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
